import React from 'react';

import { css } from '@emotion/css';
import { ChatWithDataMinMaxProposal } from '@recurrency/core-api-schema/dist/chatWithData/chatWithData';
import { TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { Typography } from 'antd';
import { colors } from 'theme/colors';

import { Button } from 'components/Button';

import { showAsyncModal } from 'utils/asyncModal';
import { formatNumber, formatUSD } from 'utils/formatting';

import { MinMaxProposalWizardModal } from './MinMaxProposalWizardModal';
import { getTotalInventoryChange } from './utils';

export function MinMaxProposalCard({ proposal }: { proposal: ChatWithDataMinMaxProposal }) {
  const totalChange = getTotalInventoryChange(proposal.rows);

  return (
    <div
      className={css`
        margin: 8px 0;
        padding: 12px 16px;
        border: 1px solid ${colors.neutral[300]};
        border-radius: 6px;
        background: ${colors.neutral[0]};
      `}
    >
      <Typography.Text strong>{proposal.title}</Typography.Text>
      <div
        className={css`
          margin: 4px 0 8px;
          color: ${colors.neutral[600]};
        `}
      >
        {proposal.rationale}
      </div>
      <div
        className={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        `}
      >
        <span>
          {formatNumber(proposal.rows.length)} item-locations · {totalChange < 0 ? '-' : '+'}
          {formatUSD(Math.abs(totalChange))} projected inventory
        </span>
        <Button
          type="primary"
          size="small"
          permissionsRequired={[TenantUserPermission.ActionExportMinMax]}
          onClick={() => showAsyncModal(MinMaxProposalWizardModal, { proposal })}
        >
          Review & export
        </Button>
      </div>
    </div>
  );
}
